import { render } from "./DetilProgressReportView.vue?vue&type=template&id=83dc061e"
import script from "./DetilProgressReportView.vue?vue&type=script&lang=js"
export * from "./DetilProgressReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__